import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import { router } from './router';
import { useAuthStore } from './stores/auth';
import { hydrateAnonymousSessionFromUrl } from './stores/anonymousSession';
import { i18n, setLocale, isSupportedLocale } from './i18n';
import './style.css';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(i18n);

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.global.locale.value as string;
}

// Restore auth state from localStorage before the router runs so route
// guards see the right `isAuthenticated` answer on a hard refresh.
useAuthStore().restoreFromStorage();

// Per ADR-0073. If the visitor arrived from the marketing site (apps/site
// hero submit → redirect), seed the anonymous session from the query
// params *before* the router runs so the guard recognises the engagement
// token and lets the onboarding route through pre-auth. Also flip the
// UI locale to match the one the visitor picked on the marketing site
// so they don't see the dashboard in a different language.
hydrateAnonymousSessionFromUrl();
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const marketingLocale = params.get('locale');
  if (marketingLocale && isSupportedLocale(marketingLocale)) {
    setLocale(marketingLocale);
  }
}

app.use(router);
app.mount('#app');
